export default "__VITE_ASSET__e5f82123__"